export const formatCurrency = (amount) => {
  if (typeof amount === 'number') {
    return `₹${amount.toLocaleString('en-IN')}`;
  }
  if (typeof amount === 'string' && amount !== '0' && amount !== '') {
    const numAmount = parseFloat(amount.replace(/,/g, ''));
    if (!isNaN(numAmount)) {
      return `₹${numAmount.toLocaleString('en-IN')}`;
    }
  }
  return '₹0';
};

export const formatDate = (dateString) => {
  const date = new Date(dateString?.split('-')?.reverse()?.join('-'));
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const getAccountTypeColor = (accType) => {
  switch (accType) {
    case 'Credit Card':
      return 'from-purple-500 to-pink-500';
    case 'Personal Loan':
      return 'from-blue-500 to-cyan-500';
    case 'Home Loan':
      return 'from-green-500 to-emerald-500';
    case 'Car Loan':
      return 'from-orange-500 to-red-500';
    default:
      return 'from-gray-500 to-slate-500';
  }
};